import { getDateFormatText } from 'app/utils/date';
import React from 'react';
import { Button } from 'ui';

import { useTranslation } from 'react-i18next';

type UploadedFileProps = {
  fileDate?: string;
  fileName?: string;
  isVisibleImg?: boolean;
  onDelete?: () => void;
  size?: string;
  url?: string;
};

function UploadedFile({ fileDate, fileName = '', isVisibleImg = false, onDelete = () => {}, size, url = '' }: UploadedFileProps): JSX.Element {
  const { t } = useTranslation(['common']);

  function onClick(event: React.MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();
    event.stopPropagation();
    onDelete();
  }

  function timestampPrventCache(): number {
    return new Date().getTime();
  }

  function onClickDownload(event: React.MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();
    event.stopPropagation();
    window.open(url, '_blank');
  }

  return (
    <div className="uploaded-file">
      <span className="uploaded-file__title">{t('common:File uploaded')}:</span>

      <div className="uploaded-file__box">
        <div className="uploaded-file__info">
          {isVisibleImg && <img className="uploaded-file__img" src={`${url}?t=${timestampPrventCache()}`} alt={fileName} />}
          <Button variant="plain-primary" isIconOnly leftIcon="download" ariaLabel={t('actions:Download')} onClick={onClickDownload} />

          <span className="uploaded-file__filename">{fileName.length > 23 ? `${fileName.substring(0, 23)}...` : fileName}</span>
          <span className="uploaded-file__size">{size}</span>
        </div>

        <div>
          {fileDate && <span className="uploaded-file__size mr-5">{t(`common:uploaded_the`, { date: getDateFormatText(fileDate) })}</span>}

          <Button variant="plain" isIconOnly leftIcon="trash" ariaLabel={t('actions:Delete')} onClick={onClick} />
        </div>
      </div>
    </div>
  );
}

export default UploadedFile;
